import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  select: {
    width: 100,
  },
  defaultSelect: {
    color: theme.palette.grey[700],
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  overFlowEllipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  progress: {
    width: 'inherit',
  },
  submitButton: {
    marginLeft: 5
  },
  partNumber: {
    maxWidth: '100px',
  },
  tableContainer: {
    flex: '1 1 auto',
    margin: `${theme.spacing(3)} 0 0`,
    padding: `0 0 ${theme.spacing(3)}`,
    height: '400px',
  },
  root: {
    paddingBottom: '5px',
    '& .MuiTypography-button': {
      paddingTop: '3px',
      fontSize: '0.74rem',
    },
  },
}));

export default useStyles;
